import React from "react"
import { Container } from "react-bootstrap"
import Layout from "../../components/Layout"
import Seo from "../../components/Seo"

export const Head = ({ location }) => {
  return <Seo
    title="Chamber Music Maryland Policies"
    keywords={[`COVID`, `Public Health`, `Concert Policy`, "Venue Policy"]}
    pathname={location.pathname}
  />
}

const Policy = () => (
  <Layout>
    <Container>
      <h1>Chamber Music Maryland Health &amp; Safety Policies</h1>
      <ul>
        <li>
         Chamber Music Maryland prioritizes the health and safety of our staff, artists,
          and audiences.
        </li>
        <li>
          All policies are subject to change; all events are subject to
          postponement or cancellation.
        </li>
        <li>
         Chamber Music Maryland will adhere to national, state, local, and venue policies
          affecting public health and safety.
        </li>
      </ul>
    </Container>
  </Layout>
)

export default Policy
